import { render, staticRenderFns } from "./b-ticket-info.vue?vue&type=template&id=6e0efd89&scoped=true"
import script from "./b-ticket-info.vue?vue&type=script&lang=ts"
export * from "./b-ticket-info.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-info.vue?vue&type=style&index=0&id=6e0efd89&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0efd89",
  null
  
)

export default component.exports